module.exports = __webpack_public_path__ + "img/longquan3.5f88c10b.png";